import { render, staticRenderFns } from "./GatewayOverview.vue?vue&type=template&id=a6228c56&"
import script from "./GatewayOverview.vue?vue&type=script&lang=js&"
export * from "./GatewayOverview.vue?vue&type=script&lang=js&"
import style0 from "./GatewayOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports